<div mat-dialog-title>
  <div>
    <div *ngIf="data.extra" class="text-muted extraData">{{data.extra}}</div>
    <div [attr.data-testId]="data.title" class="h4 mb-0">{{data.title}}</div>
  </div>
  <button mat-icon-button [mat-dialog-close]="false" *ngIf="data.displayCloseButton && !data.hideAllButtons">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<div mat-dialog-content class="pb-4">
  <div class="white-space-pre-wrap" data-testId="dialog-content" [innerHtml]="data.message"></div>
</div>
<div mat-dialog-actions *ngIf="!data.hideAllButtons">
  <button
    data-testId="close"
    mat-button
    [class.mat-flat-button]="!data.displayCloseButton"
    [color]="data.buttonColor || 'primary'"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    <mat-icon *ngIf="data.buttonIcon" svgIcon="{{data.buttonIcon}}"></mat-icon>
    {{data.buttonLabel}}
  </button>
  <button data-testId="cancel" mat-button color="primary" [mat-dialog-close]="false" *ngIf="!data.hideCancelButton">
    {{data.cancelButtonLabel ?? (staticMessage.CancelButton | staticMessage)}}
  </button>
</div>
